export default __webpack_public_path__ + "static/media/recruit_section_image_1@3x.8baf8f2d.webp";